module.exports = __webpack_public_path__ + "img/pic-4.28ce5aac.png";